import React from "react";

//@mui
import Card from "../components/mui/Card";
import Box from "../components/mui/Box";

import { useForm, SubmitHandler } from "react-hook-form";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useForgotPwdEmailActionMutation } from "../store/apis/userApi";

//component
import ResetPassword from "../components/Login/ResetPassword";
import ForgotPassword from "../components/Login/ForgotPassword";
import { toaster } from "../helper/toaster";

interface ForgotPassword {
  email: string;
}

const ForgotPasswordContainer: React.FC = () => {
  const [forgotPwdEmailAction, { data: forgotPwdResponse, isLoading }] =
    useForgotPwdEmailActionMutation();

  const navigate = useNavigate();

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<ForgotPassword>({
    defaultValues: {
      email: "",
    },
  });

  // Handle form submission
  const handleForgotPasswordSubmit: SubmitHandler<ForgotPassword> = async (
    data
  ) => {
    try {
      const response: any = await forgotPwdEmailAction({
        email: data?.email,
        portalType: "METAL_SCORE_CARD",
      });

      if (response?.data?.success) {
        navigate("/login");
      }
      toaster.success(response?.data?.message);
    } catch (err: any) {
      console.error("Error during reset link sent:", err.message || err);
    }
  };

  return (
    <div>
      <Card
        sx={{ maxWidth: 450, padding: 2.5, borderRadius: 4, boxShadow: 14 }}
      >
        <Box sx={{ margin: 4, overflow: "hidden", boxSizing: "border-box" }}>
          <ForgotPassword
            control={control}
            errors={errors}
            handleSubmit={handleSubmit(handleForgotPasswordSubmit)}
            loading={isLoading}
          />
        </Box>
      </Card>
    </div>
  );
};

export default ForgotPasswordContainer;
